module.exports = __webpack_public_path__ + "static/media/boat.0b709398.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boat.svg
// module id = 1296
// module chunks = 0